import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { ErrorFallback } from '@/app/error-boundary'
import type { AssistantContextItem } from '@/lib/assistant-context.generated'

export type RouterContext = {
  isAuthenticated: boolean
  assistantContext?: AssistantContextItem[]
}

const showDevtools = import.meta.env.MODE === 'development' && import.meta.env.VITE_DEV_TOOLS !== 'false'

const TanStackRouterDevtools = showDevtools
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    )
  : () => null

const ReactQueryDevtools = showDevtools
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : () => null

function NotFound() {
  return (
    <main className="bg-background flex min-h-screen flex-col items-center justify-center gap-2 p-6 text-center">
      <h1 className="font-heading text-foreground text-base font-medium">Not found</h1>
      <p className="text-muted-foreground text-sm">We couldn’t find that page.</p>
      <Link to="/" className="text-primary text-sm underline">
        Back to start
      </Link>
    </main>
  )
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: function RootLayout() {
    return (
      <>
        <Outlet />
        {showDevtools && (
          <Suspense>
            <TanStackRouterDevtools
              position="bottom-left"
              toggleButtonProps={{
                style: { left: '50%', transform: 'translateX(-50%)' },
              }}
            />
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
          </Suspense>
        )}
      </>
    )
  },
  notFoundComponent: NotFound,
  errorComponent: ErrorFallback,
})
